import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"padding-left":"100px","padding-top":"40px"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"50px","line-height":"1.1em","padding-bottom":"40px"} }, [
  /*#__PURE__*/_createTextVNode(" A"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Fun"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Simple"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Golf"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Game. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" Enjoy ")
], -1)
const _hoisted_3 = { style: {"font-size":"20px"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("PLAY")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("PRACTICE")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_RouterLink, {
          style: {"padding-right":"20px"},
          to: "/course"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _hoisted_5,
        _createVNode(_component_RouterLink, {
          style: {"padding-left":"20px"},
          to: "/range"
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ])
    ])
  ]))
}